// Globals
import { useTranslation } from 'react-i18next';

// Components
import { Pagination, Table } from '@/ui';
import { StyledWrapper } from '../Styled';

// Models
import { IPagination, IPaginationDTO } from '@/models/pagination.model';
import { IUser, UserStatus } from '@/models/users.model';

// Components
import userFiltersContainer from '../../containers/UsersFiltersContainer/UsersFiltersContainer';

// Helpers
import { getEntityId } from '@/utils';
import { getUsersTableColumns } from './columns';

type TUsersList = {
  usersList: IUser[];
  isLoading: boolean;
  pagination?: IPagination;
  onUserEdit: (id: string) => void;
  updateUserStatus: (id: string, status: UserStatus) => void;
  onPageChange?: (pagination: IPaginationDTO) => void;
};

const UsersList = ({ isLoading, usersList, onUserEdit, updateUserStatus, onPageChange, pagination }: TUsersList) => {
  const { t } = useTranslation(['users']);

  return (
    <StyledWrapper>
      <Table
        columns={getUsersTableColumns({ t, updateUserStatus })}
        dataSource={usersList}
        scroll={{ x: 'max-content' }}
        rowKey="PK"
        onRow={({ PK }) => ({
          onClick: () => {
            return onUserEdit(getEntityId(PK));
          },
        })}
        loading={isLoading}
        components={{
          header: {
            wrapper: userFiltersContainer,
          },
        }}
      />
      <Pagination onChange={onPageChange} cursor={pagination} loading={isLoading} />
    </StyledWrapper>
  );
};

export default UsersList;
